import React, { FC, useMemo } from "react";
import stl from "./Socials.module.scss";
import { useStore } from "effector-react";
import { SettingsEndpoint } from "../../store/endpoints";
import { useTranslation } from "react-i18next";
import { AppConfig } from "../../config";

const Socials: FC = () => {
  const { t } = useTranslation(AppConfig.translationFileNames.base);
  const { data: settings } = useStore(SettingsEndpoint.store);

  const links = useMemo<{ title: string; url: string; img: string }[]>(() => {
    const res: { title: string; url: string; img: string }[] = [];

    if (settings?.facebook) {
      res.push({
        title: t("facebook"),
        url: settings.facebook,
        img: "https://i.ibb.co/Qj8WY3S/Fb.png",
      });
    }

    if (settings?.instagram) {
      res.push({
        title: t("instagram"),
        url: settings.instagram,
        img: "https://i.ibb.co/4fgj9Rx/Insta.png",
      });
    }

    if (settings?.linkedin) {
      res.push({
        title: t("linkedin"),
        url: settings.linkedin,
        img: "https://i.ibb.co/nBNqKLR/LinkedIn.png",
      });
    }

    return res;
  }, [t, settings]);

  return (
    <ul className={stl.links}>
      {links.map(({ title, img, url }) => (
        <li key={title + url} className={stl.link}>
          <a href={url} target={"_blank"} rel={"noreferrer"}>
            <img src={img} alt={title} />
          </a>
        </li>
      ))}
    </ul>
  );
};

export default Socials;
